import React from 'react'

const Header: React.FC = () => {
  return (
    <header className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex justify-center md:justify-end md:mr-36 md:mt-4">
          <img 
            src="/logo.png" 
            alt="RobotStack" 
            className="h-32 md:h-28 w-auto opacity-80"
          />
        </div>
      </div>
    </header>
  )
}

export default Header
